import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { Input } from "@src/lib/ui/Input";
import { useToast } from "@src/lib/hooks/useToast";
import { FC, useState } from "react";
import isURL from "validator/lib/isURL";
import { cn } from "@src/lib/utils/cn";
import EyeOutlineIcon from "@src/lib/icons/18px/eye-outline";
import LinkIcon from "@src/lib/icons/18px/link";
import { Popover, PopoverContent, PopoverTrigger } from "@src/lib/ui/Popover";

type Props = {
  onAddLink: (url: string) => void;
  isDragActive: boolean;
  openFileSelector: () => void;
};

const UploadFilesDefaultState: FC<Props> = ({
  onAddLink,
  isDragActive,
  openFileSelector,
}) => {
  const [link, setLink] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { addErrorToast } = useToast();
  return (
    <div
      className={cn(
        "flex h-full w-[500px] flex-col items-center justify-center rounded-2xl",
        "border-2 border-dashed border-gray-5",
        isDragActive && "bg-gray-4-alpha",
      )}
    >
      <div className="flex flex-col items-center justify-center gap-7">
        <img
          src="/images/upload-files.svg"
          alt="help-center"
          className="size-[136px]"
        />
        <div className="flex flex-col items-center gap-1">
          <Text variant="display-bold" multiline>
            Upload your resources
          </Text>
          <Text
            variant="compact-description"
            multiline
            className="w-[275px] text-center"
          >
            You can upload multiple files at once
          </Text>
        </div>
        <div className="flex gap-3">
          <Button onClick={openFileSelector} size="lg" className="w-[140px]">
            <EyeOutlineIcon className="size-4" />
            Browse files
          </Button>
          <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
            <PopoverTrigger asChild>
              <Button variant="outline" size="lg" className="w-[140px]">
                <LinkIcon className="size-4" />
                Paste link
              </Button>
            </PopoverTrigger>
            <PopoverContent className="flex w-auto items-center gap-2 p-4">
              <Input
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Paste link here"
                className="w-[250px]"
              />
              <Button
                disabled={!link}
                onClick={() => {
                  if (isURL(link, { protocols: ["https"] })) {
                    onAddLink(link);
                    setPopoverOpen(false);
                    setLink("");
                  } else {
                    addErrorToast({
                      message: "Invalid link. Please paste a valid link.",
                      callsite: "paste_media_link",
                    });
                  }
                }}
              >
                Add
              </Button>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default UploadFilesDefaultState;
